import toast from 'react-hot-toast';
import { contractsApi, CreateContractPayload } from '../api/contractsApi';
import { PendingContractFile } from '../components/contracts/ContractFileField';
import { getApiErrorMessage } from './apiErrors';

export type SaveContractWithFilesResult = 'saved' | 'contract_failed' | 'upload_partial';

export async function saveContractWithPendingFiles(options: {
  isEdit: boolean;
  contractId?: string | null;
  payload: CreateContractPayload;
  pendingFiles: PendingContractFile[];
}): Promise<SaveContractWithFilesResult> {
  const { isEdit, contractId, payload, pendingFiles } = options;

  let savedId = contractId || '';
  try {
    if (isEdit && contractId) {
      await contractsApi.update(contractId, payload);
      savedId = contractId;
    } else {
      const created = await contractsApi.create(payload);
      savedId = created.id;
    }
  } catch (err: unknown) {
    toast.error(getApiErrorMessage(err, 'Không thể lưu hợp đồng'));
    return 'contract_failed';
  }

  if (savedId && pendingFiles.length > 0) {
    const uploadErrors: string[] = [];
    for (const pending of pendingFiles) {
      try {
        await contractsApi.uploadContractFile(savedId, pending.file, {
          fileKind: pending.fileKind,
          notes: pending.notes,
        });
      } catch (err: unknown) {
        uploadErrors.push(
          `${pending.file.name}: ${getApiErrorMessage(err, 'Không thể tải file lên')}`,
        );
      }
    }
    if (uploadErrors.length > 0) {
      toast.error(
        isEdit
          ? `Hợp đồng đã cập nhật nhưng một số file chưa tải lên:\n${uploadErrors.join('\n')}`
          : `Hợp đồng đã tạo nhưng một số file chưa tải lên:\n${uploadErrors.join('\n')}`,
      );
      return 'upload_partial';
    }
  }

  return 'saved';
}
